module.exports = __webpack_public_path__ + "img/maintenance.08f5cba6.jpg";